
export function * flattenObj (obj, prefixName = "") {
  if (typeof obj !== 'object') {
    yield [prefixName, obj]
  } else {
    if (prefixName !== "") {
      yield [prefixName, {}]
    }
    if (obj !== null) {
      for (const [key, value] of Object.entries(obj ?? {})) {
        yield * flattenObj(value, prefixName !== "" ? `${prefixName}/${key}` : `${key}`)
      }
    }
  }
}

export function erectObj (keyValueList) {
  const retval = {}
  for (const [key, value] of keyValueList) {
    const keyparts = key.split("/")
    const target = keyparts.slice(0, -1).reduce((prev, curr) => {
      if (!Object.prototype.hasOwnProperty.call(prev, curr)) {
        prev[curr] = {}
      }
      return prev[curr]
    }, retval)
    target[keyparts[keyparts.length - 1]] = value
  }
  return retval
}

export function removeEmptyProperties (obj) {
  return Object.fromEntries(Object.entries(obj).filter(([_, v]) => v != null && v !== "" && !(v && Object.keys(v).length === 0)))
}

export const ALLOW_RECURRING_PAYMENTS = "allow_recurring_payments"
export const ALLOW_EMAIL_CONTACT = "allow_email_contact"
export const ALLOW_CASH_PAYMENTS = "allow_cash_payments"
export const ALLOW_COLLECTION_SPLIT = "allow_collection_split"
export const DONATION_RECEIPT_FOR_COLLECTION = "donation_receipt_for_collection"
// export const REQUEST_DONATION_RECEIPT = "request_donation_receipt"
// export const REQUIRE_PDATA = "require_pdata"

export const FEATURE_TO_SETTINGS_KEY_MAP = {
  [ALLOW_RECURRING_PAYMENTS]: 'Dauerspendenmodul',
  [ALLOW_EMAIL_CONTACT]: 'Informationsanforderungen',
  [ALLOW_CASH_PAYMENTS]: 'Barspendenmodul',
  [ALLOW_COLLECTION_SPLIT]: 'Sammlungsgruppen'
  // request_donation_receipt: 'Spendenbescheinigungen',
  // donation_receipt_for_collection: 'Spendenbescheinigungen für Kollekten',
}

export const FEATURE_RESOURCE_TYPE_MAP = {
  VERANSTALTUNG_APP_FEATURE: 'VeranstaltungAppFeature',
  ADVANCED_NOTIFICATION_FEATURE: 'AdvancedNotificationFeature',
  DISBURSEMENT_ORDER_FEATURE: 'DisbursementOrderFeature',
  KIRCHGELD_DIGITAL_FEATURE: 'KirchgeldDigitalFeature',
  TAGGED_COLLECTION_PLAN_FEATURE: 'TaggedCollectionPlanFeature',
  DONATION_METER_FEATURE: 'DonationMeterFeature',
}

// Backend FeatureType value per resourcetype (used by the feature/ endpoint)
export const FEATURE_TYPE_BY_RESOURCE_TYPE = {
  VeranstaltungAppFeature: 'veranstaltung_app',
  AdvancedNotificationFeature: 'advanced_notification',
  DisbursementOrderFeature: 'disbursementorder',
  KirchgeldDigitalFeature: 'kirchgeld_digital',
  TaggedCollectionPlanFeature: 'tagged_collection_plan',
  DonationMeterFeature: 'donation_meter',
}

// Explanations shown on hover, keyed by settings id or feature resourcetype
export const FEATURE_HELP_TEXTS = {
  [ALLOW_RECURRING_PAYMENTS]: 'Erlaubt wiederkehrende Spenden per SEPA-Lastschrift.',
  require_pdata: 'Verpflichtende Angabe von Spenderdaten – anonyme Spenden sind nicht mehr möglich.',
  [ALLOW_COLLECTION_SPLIT]: 'Erlaubt Spenden zu gewählten Anteilen, z. B. 50/50 oder 25/75.',
  [ALLOW_CASH_PAYMENTS]: 'Erlaubt die Verbuchung von Bargeldspenden.',
  AdvancedNotificationFeature: 'Informationen über bevorstehende oder abgeschlossene Sammlungen per Mail. Zwischensummen.',
  DisbursementOrderFeature: 'Weiterleitungsspenden erzeugen eine Auszahlungsanordnung (PDF) mit zugehöriger Überweisungsdatei. ' +
    'Zusätzliche Felder wie „externer Spendenempfänger“, Bankverbindung etc. können bei der Anlage einer Sammlung im System hinterlegt werden und landen in der Abgleichliste.',
  TaggedCollectionPlanFeature: 'Erlaubt die Einschränkung der Vererbung von Sammlungen auf Teilgruppen.',
}

// The backend only looks at an organization's own feature for these (inherit is ignored)
export const NON_INHERITABLE_FEATURE_TYPES = ['veranstaltung_app', 'kirchgeld_digital']

// Feature types which can be created in the frontend (Kollektenweiterleitung needs
// templates and stays in the Django admin)
export const CREATABLE_FEATURE_RESOURCE_TYPES = [
  FEATURE_RESOURCE_TYPE_MAP.ADVANCED_NOTIFICATION_FEATURE,
  FEATURE_RESOURCE_TYPE_MAP.TAGGED_COLLECTION_PLAN_FEATURE,
  FEATURE_RESOURCE_TYPE_MAP.DONATION_METER_FEATURE,
  FEATURE_RESOURCE_TYPE_MAP.VERANSTALTUNG_APP_FEATURE,
  FEATURE_RESOURCE_TYPE_MAP.KIRCHGELD_DIGITAL_FEATURE,
]
